"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _builderOptions = _interopRequireDefault(require("./data/builderOptions"));

var _grid = require("@jsluna/grid");

var _form = require("@jsluna/form");

var _uuid = require("uuid");

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var renderOptionComponent = function renderOptionComponent(option, value, setQuestion, questionId, removedRatings) {
  switch (option.componentType) {
    case 'checkbox':
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ln-u-padding-bottom*2"
      }, /*#__PURE__*/_react.default.createElement(_form.Label, {
        htmlFor: questionId + "-" + option.questionField
      }, option.label), /*#__PURE__*/_react.default.createElement(_form.Checkbox, _extends({
        key: (0, _uuid.v1)()
      }, option.props, {
        onChange: function onChange() {
          return setQuestion(!value, option.questionField);
        },
        fullWidth: true,
        outlined: true,
        name: questionId + "-" + option.questionField,
        checked: value,
        className: "survey__checkbox"
      })));

    case 'textInput':
      return /*#__PURE__*/_react.default.createElement(_form.TextInputField, _extends({
        label: option.label
      }, option.props, {
        value: value,
        onChange: function onChange(e) {
          setQuestion(e.target.value, option.questionField);
        },
        name: questionId + "-" + option.questionField
      }));

    case 'radioButton':
      return /*#__PURE__*/_react.default.createElement(_form.RadioButtonField, _extends({
        key: (0, _uuid.v1)(),
        label: option.label
      }, option.props, {
        options: option.props.options.map(function (x) {
          return Object.assign({}, x, {
            checked: value === x.value
          });
        }),
        onChange: function onChange(e) {
          if (option.forceBranchingCleanup) {
            var removedValues = option.props.options.map(function (x) {
              return x.value;
            }).filter(function (x) {
              return x > e.target.value;
            });
            removedRatings(questionId, removedValues);
          }

          setQuestion(parseInt(e.target.value), option.questionField);
        },
        fullWidth: true,
        outlined: true,
        name: questionId + "-" + option.questionField,
        className: "survey__checkbox"
      }));

    default:
      break;
  }
};

var QuestionOptionBuilder = function QuestionOptionBuilder(_ref) {
  var question = _ref.question,
      setQuestion = _ref.setQuestion,
      removedRatings = _ref.removedRatings;

  var questionOptions = _builderOptions.default.filter(function (x) {
    return x.component === question.component.type;
  })[0].options;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, questionOptions.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/1",
      key: question.id + "-" + x.questionField
    }, renderOptionComponent(x, (0, _lodash.get)(question, x.questionField), setQuestion, question.id, removedRatings));
  }));
};

QuestionOptionBuilder.propTypes = {
  /** Object containing the question information */
  question: _propTypes.default.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    }),

    /** Indicates whether the question is currently being edited */
    editMode: _propTypes.default.bool
  }).isRequired,

  /** Function to update the values of the question object */
  setQuestion: _propTypes.default.func.isRequired,

  /** Function to handle removed ratings and removing any linked branches */
  removedRatings: _propTypes.default.func.isRequired
};
var _default = QuestionOptionBuilder;
exports.default = _default;